import { TransformDate } from '../../../shared/decorators/transform-date.decorator';

/**
 * Release billable event DTO
 */
export class ReleaseBillableEventDto {
	idempotencyKey!: string;
	@TransformDate()
	dispatchedAt?: Date;
	dispatchError?: string;
	terminal?: boolean;
	@TransformDate()
	nextRetryAt?: Date;
}
